import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { RecoilRoot } from 'recoil';
import App from './App';
import './index.css';

const container = document.getElementById('root');

const app = (
  <RecoilRoot>
    <App />
  </RecoilRoot>
);

// اگر صفحه از قبل پیش‌رندر شده باشد (HTML آماده داخل root هست) → hydrate
// در غیر این صورت رندر عادی
if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
